import React from 'react';

import { Box, Text } from '@opendoor/bricks-next';
import { getHeaderFooterStaticProps } from 'cms';
import type { HeaderFooterStaticProps } from 'cms';
import type { GetStaticProps } from 'next';

import Layout from '../components/landing-pages-v2/Layout';
import NewSellerFlowAddressInput from '../components/shared/NewSellerFlowAddressInput';

const trackingTaxonomy = 'new_homepage';

/** Address entry screen to start the seller input flow in the mobile native app (via a web view) */
const AddressEntryMobile: React.FC<HeaderFooterStaticProps> = ({ header, footer }) => {
  return (
    <Layout
      header={header ?? undefined}
      footer={footer ?? undefined}
      slug="/address-entry-mobile"
      hideHeader
      hideFooter
    >
      <Box py="$8" px="$8" gap="$5">
        <Text typography="$subheaderXsmall" tag="h4">
          Let’s start your offer
        </Text>
        <Text typography="$bodyMedium" tag="p">
          Enter your address to get started. This helps us find sales data for your home and other
          homes nearby.
        </Text>
        <NewSellerFlowAddressInput
          trackingTaxonomy={trackingTaxonomy}
          inputLocation="address-entry-mobile-page"
          placeholder="125 W Muriel Dr"
          channel="DEFAULT"
        />
      </Box>
    </Layout>
  );
};

export const getStaticProps: GetStaticProps<HeaderFooterStaticProps> = getHeaderFooterStaticProps;

export default AddressEntryMobile;
